/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Embed_Captions_Pricing_Grand_Total_LabelInputs */

const en_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total (${i?.count} jobs):`)
};

const fr_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total (${i?.count} tâches) :`)
};

const de_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gesamt (${i?.count} Jobs):`)
};

const it_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totale (${i?.count} lavori):`)
};

const ru_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Итого (заданий: ${i?.count}):`)
};

const es_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total (${i?.count} trabajos):`)
};

const zh_cn2_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`总计（${i?.count} 个任务）：`)
};

const ja_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`合計（${i?.count} ジョブ）:`)
};

const hi_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कुल (${i?.count} जॉब):`)
};

const pt_pt2_embed_captions_pricing_grand_total_label = /** @type {(inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total (${i?.count} trabalhos):`)
};

/**
* | output |
* | --- |
* | "Total ({count} jobs):" |
*
* @param {Embed_Captions_Pricing_Grand_Total_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_grand_total_label = /** @type {((inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Grand_Total_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "de") return de_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "it") return it_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "ru") return ru_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "es") return es_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "ja") return ja_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "hi") return hi_embed_captions_pricing_grand_total_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_pricing_grand_total_label(inputs)
	return en_embed_captions_pricing_grand_total_label(inputs)
});